import { systemTypes } from "keys/systems";
import { app } from "router/routes";
import { ReactComponent as StudentSystemIcon } from 'assets/icons/StudentSystem.svg'
import { ReactComponent as TranscriptionSystemIcon } from 'assets/icons/TranscriptionSystem.svg'

/**
 * הגדרת המערכות השונות באתר
 */
export const SYSTEMS_CONFIG = {
    ["school"]: {
        id: systemTypes.school,
        root: app.dashboard,
        icon: StudentSystemIcon,
        label: 'מערכת תלמידים'
    },
    ["administrative"]: {
        id: systemTypes.administrative,
        root: app.markingWords,
        icon: TranscriptionSystemIcon,
        label: 'מערכת ניהול'
    }
}

export const SIDEBAR_NAMES = {
    trainingAssessments: "trainingAssessments",
    primaryAssessments: "primaryAssessments",
    tickets: "tickets",
    newsletters: "newsletters",
    tutorials: "tutorials",
    createAssessments: "createAssessments",
    createAssessmentDef: "createAssessmentDef",
    createBattery: "createBattery",
    assessmentLibrary: "assessmentLibrary",
    normalizer: "normalizer",
    childDevelopment: "childDevelopment",
    wordReadability: "wordReadability",
    textReadability: "textReadability",
    voiceLab: "voiceLab",
    linguisticLab: "linguisticLab",
    dashboard: "dashboard",
    performAssessments: "performAssessments",
    practiceAssessments: "practiceAssessments",
    performPractices: "performPractices",
    createPractices: "createPractices",
    assessments: "assessments",
    testTakers: "testTakers",
    affiliations: "affiliations",
    affiliationManagement: "affiliationManagement",
    systematicReview: "systematicReview",
    assessmentExecution: "assessmentExecution",
    generalPerformanceReview: "generalPerformanceReview",
    achievementGraph: "achievementGraph",
    progressGraphs: "progressGraphs",
    users: "users",
    transcriptionSystem: "transcriptionSystem",
    transcriptionManage: "transcriptionmManage",
    markingWords: "markingWords",
    audioCutting: "audioCutting",
    transcription: "transcription",
    assessmentCosts: "assessmentCosts",
    stuckReasons: "stuckReasons"
}